import { j as json } from "../../../../../chunks/index.js";
import { createRequire } from "module";
const require2 = createRequire(import.meta.url);
const { PrismaClient } = require2("@prisma/client");
const prisma = new PrismaClient();
const GET = async ({ params }) => {
  const { id } = params;
  try {
    const existingResponse = await prisma.response.findUnique({
      where: { id }
      // Find the response by ID
    });
    if (existingResponse) {
      return json(existingResponse);
    } else {
      return json({ message: "Response not found" }, { status: 404 });
    }
  } catch (error) {
    console.error("Error fetching existing response:", error);
    return json({ message: "Error fetching existing response", error: error.message }, { status: 500 });
  }
};
const PATCH = async ({ request, params }) => {
  const { id } = params;
  const { value, createdAt } = await request.json();
  try {
    const updatedResponse = await prisma.response.update({
      where: { id },
      // Find the response by ID
      data: { value, createdAt }
      // Update the value
    });
    return json(updatedResponse, { status: 200 });
  } catch (error) {
    console.error("Error updating response:", error);
    return json({ error: "Failed to update response" }, { status: 500 });
  }
};
export {
  GET,
  PATCH
};
